// Count dates identify a calendar day. API midnight-UTC serialization must not
// shift that day when a viewer's timezone is west of UTC.
export function inventoryCountCalendarDate(value) {
    if (typeof value !== "string") return "-"
    const match = value.match(/^(\d{4})-(\d{2})-(\d{2})(?:$|T)/)
    if (!match) return "-"
    const year = Number(match[1])
    const month = Number(match[2])
    const day = Number(match[3])
    const date = new Date(Date.UTC(year, month - 1, day))
    if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) return "-"
    return `${match[1]}-${match[2]}-${match[3]}`
}
